import { HelpVideo } from '../../../app/core/help/HelpVideo';

export const HideIdentitiesHaug = HelpVideo(
    'HideIdentities',
    'Editor / Features',
    'Hide Identities',
    20020,
    'https://s.ludi.co/app/haug/20020-hide-identities.mp4'
);
